var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mixes && _vm.mixes.length)?_c('div',{class:_vm.$style.section},[_c('BaseSection',{attrs:{"show-all-link":{ name: 'browse/mixes/recently' },"title":"Recently Played","show-all-title":"Browse All","padded":""}},[_c('MixGridBlock',{attrs:{"mixes":_vm.mixes}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }